module.exports = __webpack_public_path__ + "static/img/codeIcon.4da4d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/newIcon/codeIcon.png
// module id = t8xT
// module chunks = 1